import styled from "styled-components";

export const TabPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  height: 100%;
  min-height: 0;
`;

export const TabPanelContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 24px;
  box-sizing: border-box;
  gap: 16px;
`;

export const BoxCriteria = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const BoxImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const TabPanelActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;
